import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { backendErrorNotification } from '../../../components/Notification';
import { getOrderDisplayDecimals } from '../../../services/requests/orders/getOrderDisplayDecimals';
import { orderDecimalPlaces } from './orderMoney';

const OrderMoneyPrecisionContext = createContext<number | undefined>(undefined);

// Uma leitura por entrada na tela. Modais aninhados reutilizam o mesmo contexto.
// Sem cache persistente: outra sessão ou tenant nunca herda o valor anterior.
export function OrderMoneyPrecisionProvider({ children }: { children: ReactNode }) {
  const parent = useContext(OrderMoneyPrecisionContext);
  const [decimals, setDecimals] = useState(2);

  useEffect(() => {
    if (parent !== undefined) return;
    let active = true;
    getOrderDisplayDecimals().then((value) => {
      if (active) setDecimals(orderDecimalPlaces(value));
    }).catch((error) => {
      if (active) backendErrorNotification(error);
    });
    return () => { active = false; };
  }, [parent]);

  return (
    <OrderMoneyPrecisionContext.Provider value={parent ?? decimals}>
      {children}
    </OrderMoneyPrecisionContext.Provider>
  );
}

export const useOrderMoneyDecimals = () => useContext(OrderMoneyPrecisionContext) ?? 2;
